<template>
  <OrderItemApplyAllPopover ref="applyPopover" headerTitle="Apply Supplier" :itemList="validItemList" :disabled="!hasContact" @applySettings="applySettings">

    <FormSearchableSelect
      :options="supplierLookupList"
      v-model="contactId"
      :dropdownAutoWidth="true"
      placeholder="Supplier"
      />
    <div class="m-3" />

  </OrderItemApplyAllPopover>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import OrderItemApplyAllPopover from '@/modules/orders/components/orderItemApplyAllPopover.vue'

import { InventoryStockTypes, UOMTypes } from '@/store/types'

export default {
  name: 'OrderItemApplyAllSupplierPopover',
  mixins: [form],
  components: {
    OrderItemApplyAllPopover
  },
  props: {
    supplierLookupList: Array,
    itemList: Array
  },
  computed: {
    validItemList() {
      return this.itemList
      .filter(item => item.isExternal)
      .map(item => {
        var info = item.glassWidth ? ` - ${item.glassHeight}x${item.glassWidth}` : ''
        return {
          id: item.id,
          name: `${item.stock.code} - ${item.stock.name}${info}`
        }
      })
    },
    hasContact() {
      return this.contactId != null
    }
  },
  data() {
    return {
      contactId: null
    }
  },
  methods: {
    displayFromElement(element) {
      this.flagList = []
      this.contactId = null

      this.$refs.applyPopover.displayFromElement(element)
    },
    applySettings(itemList) {

      this.$emit('applySupplier', {
        supplierContactId: this.contactId,
        itemList: itemList
      })
    }
    
  }
}
</script>